var _rect, _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDriverSeat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "silla_conductor",
    "data-name": "silla conductor",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.85,
    height: 28.349,
    viewBox: "0 0 49.85 28.349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_233",
    "data-name": "Rectangle 233",
    width: 26,
    height: 26,
    rx: 3,
    transform: "translate(22 1)",
    fill: "#707070"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M134.729,271.336a4.133,4.133,0,0,0-4.12-3.908H116.017v.59h-5.359a3.618,3.618,0,0,0-3.614,3.614v20.087a3.618,3.618,0,0,0,3.614,3.614h5.766v.444h14.185a4.136,4.136,0,0,0,4.131-4.131v-.505a1.491,1.491,0,0,0,.966-1.393V272.733a1.491,1.491,0,0,0-.977-1.4m-24.071,22.617a2.237,2.237,0,0,1-2.235-2.235V271.632a2.237,2.237,0,0,1,2.235-2.235h5.359v.445h14.592a1.718,1.718,0,0,1,1.685,1.4h-.525a1.494,1.494,0,0,0-1.494,1.494v17.014a1.494,1.494,0,0,0,1.494,1.494h.557v.4a1.719,1.719,0,0,1-1.717,1.717H116.424v.59Z",
    transform: "translate(-85.856 -267.428)",
    fill: "#2c2c2c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M40.049,271.352a13.9,13.9,0,1,0,13.9,13.9,13.9,13.9,0,0,0-13.9-13.9m0,3.145a10.7,10.7,0,0,1,5.845,1.73l-4.428,4.428a4.81,4.81,0,0,0-6.014,3.183H29.392A10.752,10.752,0,0,1,40.049,274.5m2.409,10.752a2.409,2.409,0,1,1-2.409-2.409,2.409,2.409,0,0,1,2.409,2.409m-13.069,1.388h6.058a4.8,4.8,0,0,0,6.7,2.932l4.312,4.312a10.751,10.751,0,0,1-17.071-7.244m19.081,5.294L44.2,287.664a4.786,4.786,0,0,0-.387-5.4l4.218-4.218a10.746,10.746,0,0,1,.437,13.883",
    transform: "translate(-26.151 -271.352)",
    fill: "#2c2c2c"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(11 11)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDriverSeat);
export default __webpack_public_path__ + "static/media/icon_driver_seat.168ee52e2525e006b265a9974ec0091e.svg";
export { ForwardRef as ReactComponent };